import React from 'react'
import WinnersSVG from '../img/winners.svg'

function Results({correctAnswers, tryAgain}) {
  return (<>
    <img src={WinnersSVG} className='mx-auto pt-6 pb-12' alt='Winners SVG' />
    <h2 className='text-center text-3xl font-bold text-slate-600'>Results</h2>
    <p className='text-center text-slate-600'>You got <span className='text text-green-500 text-xl font-bold'>{correctAnswers}</span> correct answers</p>
    <button onClick={tryAgain} className='mx-auto block mt-12 ring-2 text-slate-600 ring-slate-600 font-medium rounded-lg py-2 px-6 hover:bg-slate-600/50 hover:ring-slate-600/50 hover:text-white'>Try Again</button>
  </>);
}

export default Results